define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../shared/dataLogs", "../../models/CustomerStatusModel", "../../models/UserContext"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DataLogs, CustomerStatusModel, UserContext) {
    "use strict";
    var CustomerStatuses = /** @class */ (function () {
        function CustomerStatuses() {
            this.userCanEdit = ko.observable(UserContext.hasAccess("Admin,CustomerStatus.Edit,CustomerStatus.Delete"));
            this.userCanDelete = ko.observable(UserContext.hasAccess("Admin,CustomerStatus.Delete"));
            this.editModel = ko.observable(new CustomerStatusModel());
            this.clearFilterInProgress = false;
            this.filterByAny = ko.observable("");
        }
        CustomerStatuses.prototype.init = function () {
            var self = this;
            $("#page-title").text("Customer Statuses");
            tools.ajaxGet({
                url: "/CustomerStatus/GetCustomerStatusesLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.lookupLists = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.initCustomerStatuses(self.lookupLists.GridStructures.CustomerStatusStructure);
                    ko.applyBindings(self, document.getElementById("main-container"));
                    //self.initMenu();
                    //self.initLogs();
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        CustomerStatuses.prototype.initCustomerStatuses = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            columns.push({
                field: "",
                title: "",
                width: "100px",
                sortable: false,
                template: function (dataItem) {
                    var html = "";
                    if (self.userCanEdit()) {
                        html += '<a class="btn btn-sm btn-info btn-edit" href="#"><i class="fa fa-edit "></i></a>';
                    }
                    if (self.userCanDelete()) {
                        html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove" href="#"><i class="fa fa-trash-o "></i></button>';
                    }
                    return html;
                }
            });
            var gridId = "customerStatusesTable";
            self.CustomerStatusTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                gridOptions: {
                    columns: columns,
                    autoBind: true,
                    resizable: true,
                    //reorderable: true,
                    //mobile: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row menu",
                        extra: false
                    }
                    //toolbar: kendo.template($("#product-type-toolbar-template").html())
                },
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/CustomerStatus/GetCustomerStatuses",
                            type: "POST",
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model,
                        data: function (response) { return response.Data; },
                        total: "Total"
                    }
                },
                gridId: gridId,
                showPagerOnTop: false,
                enableExport: {
                    entityName: "CustomerStatus",
                    title: "Customer Statuses",
                    enablePdf: false
                },
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.CustomerStatusTable.initGrid(gridOptions);
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.CustomerStatusTable.refresh();
            });
            $("#" + gridId + " tbody").on("click", ".btn-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.editCustomerStatus(data.Id);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.deleteCustomerStatusConfirm(data.Id, data.Name);
                event.preventDefault();
            });
        };
        CustomerStatuses.prototype.editCustomerStatus = function (id) {
            var self = this;
            var title = id > 0 ? "Edit Customer Status" : "Add Customer Status";
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    if (!self.editModel().Name()) {
                        tools.error("Name is required");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.saveCustomerStatus(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if (!isNaN(id)) {
                        getModelCall = tools.ajaxGet({
                            url: "/CustomerStatus/GetCustomerStatusById",
                            data: { id: id },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new CustomerStatusModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new CustomerStatusModel());
                    }
                    $.when(getModelCall).done(function () {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'customer-status-edit-template', data: editModel }\"></div>");
                        ko.applyBindings(self, modal);
                    });
                }
            });
        };
        CustomerStatuses.prototype.saveCustomerStatus = function (btn, modal) {
            var _this = this;
            var self = this;
            var obj = ko.mapping.toJS(self.editModel);
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CustomerStatus/SaveCustomerStatus",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    _this.CustomerStatusTable.refresh();
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        CustomerStatuses.prototype.deleteCustomerStatusConfirm = function (id, name) {
            var self = this;
            tools.confirmModal({
                title: "Delete Customer Status",
                text: 'Are you sure you want to delete customer status "' + name + '"?',
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.deleteCustomerStatus(id);
            });
        };
        CustomerStatuses.prototype.deleteCustomerStatus = function (id) {
            var self = this;
            var data = {
                id: id
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CustomerStatus/DeleteCustomerStatusConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Customer status deleted successfully");
                    self.CustomerStatusTable.refresh();
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        CustomerStatuses.prototype.clearFilter = function () {
            var self = this;
            self.filterByAny("");
        };
        CustomerStatuses.prototype.exportTo = function () {
            var self = this;
            self.CustomerStatusTable.exportTo();
        };
        CustomerStatuses.prototype.initLogs = function () {
            if (UserContext.hasAccess("Admin")) {
                var dataLogs = new DataLogs("CustomerStatus");
                dataLogs.initKendoLogs("divLogsTable");
            }
        };
        return CustomerStatuses;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/CustomerStatus/Index")) {
            log.log("Initialize Customer Statuses");
            $(function () {
                (new CustomerStatuses()).init();
            });
        }
    }, 0);
    return CustomerStatuses;
});
//# sourceMappingURL=customerStatuses.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/settings/customerStatuses.js
// module id = 226
// module chunks = 2